import React from 'react';
import BannerBg from "../../../assets/images/shapes/shape-02.png";


const About = () => {
  return (
    <section className="about__section p_relative see__pad">
      <div className="pattern-layer">
        <div
          className="pattern-2 p_absolute"
          data-parallax='{"x": -50}'
          style={{ backgroundImage: `url(${BannerBg})` }}
        ></div>
      </div>
      <div className="boild__text">
        <h1>Epitome Research And Innovations Inc.</h1>
      </div>
      <div className="auto-container">
        <div className="row" style={{ paddingTop: "8vh", paddingBottom: "10px" }}>
          {/* <div className="col-lg-6 col-md-12">
            <div className="about__block p_relative">
              <figure
                className="wow zoomIn animated"
                data-wow-delay="100ms"
                data-wow-duration="1500ms"
              >
                <img src={AboutUs} alt="" />
              </figure>
              <div
                className="funfact__content about"
                style={{ backgroundImage: `url(${shape1})` }}
              >
                <div className="count-outer count-box">
                  <h1 className="count-text">
                  <CountUp start={0} end={10} /><span>K+</span>
                  </h1>
                  
                </div>
                <p>World wide Client</p>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-1"></div> */}
          <div className="col-lg-12 col-md-12">
            <div className="about__text__block">
              <div className="sub__title">
                <h4>About Company</h4>
              </div>
              <div className="title two">
                <h2>
                  Driving Innovation in R&D with <span>Cutting-Edge Solutions</span>.
                </h2>
              </div>
              <div className="texts">
                <p style={{ lineHeight: "normal", fontSize: "large" }}>
                Epitome Research and Innovations Inc. (ERI) was founded in 2021 by Dr. Satish Chimakurthi, an accomplished researcher with a deep passion for solving complex challenges at the intersection of engineering, life sciences, and healthcare. Recognizing the need for innovative, high-impact solutions, ERI was established to develop cutting-edge technologies by integrating software, hardware, and advanced computational techniques, ensuring tailored approaches to the unique demands of each problem.
                <br/><br/>Since its inception, ERI has successfully executed numerous projects, delivering state-of-the-art solutions in areas such as engineering simulation, AI-driven automation, anomaly detection, and next-generation wearable technology. As a federal prime contractor, ERI has built strong relationships with key agencies within the Department of Defense (DoD), including the U.S. Army, U.S. Air Force, Missile Defense Agency, and Defense Health Agency.
                <br/><br/>Beyond government collaborations, ERI actively partners with leading universities and private firms, fostering a multidisciplinary ecosystem of research, innovation, and technology development. With a commitment to advancing science and engineering, ERI continues to push boundaries, driving the future of technology-driven solutions for defense, healthcare, and commercial sectors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
